"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProfileLink = void 0;
var react_1 = __importDefault(require("react"));
var react_2 = require("@chakra-ui/react");
var DropdownOption_1 = require("./_shared/DropdownOption");
var useHeaderProps_1 = require("../hooks/useHeaderProps");
var UserProfileLink = function (_a) {
    var _b;
    var dataFeatureId = _a.dataFeatureId, title = _a.title, props = __rest(_a, ["dataFeatureId", "title"]);
    var _c = (0, useHeaderProps_1.useHeaderProps)(), colorSet = _c.colorSet, user = _c.user;
    return (react_1.default.createElement(DropdownOption_1.DropdownOption, { key: props.key, href: (_b = props.href) !== null && _b !== void 0 ? _b : '', className: props.className, "data-feature-id": dataFeatureId, pl: 2, borderBottom: "solid 1px", borderColor: "gray.200" },
        react_1.default.createElement(react_2.Flex, { verticalAlign: "top" },
            react_1.default.createElement(react_2.Avatar, { size: "md", outline: "1px solid", outlineColor: colorSet === null || colorSet === void 0 ? void 0 : colorSet.backgroundBorder, name: user === null || user === void 0 ? void 0 : user.username, src: (user === null || user === void 0 ? void 0 : user.hasCustomAvatar) ? user === null || user === void 0 ? void 0 : user.userAvatarUrl : undefined }),
            react_1.default.createElement(react_2.VStack, { align: "left", pl: 2, mt: 0, gap: 0 },
                react_1.default.createElement(react_2.Text, { mb: 0, mt: 0 }, user === null || user === void 0 ? void 0 : user.username),
                react_1.default.createElement(react_2.Text, { mb: 0, mt: 0, color: "gray.600", fontSize: "sm" }, title)))));
};
exports.UserProfileLink = UserProfileLink;
